export default {
  vueInstance: false,
  ui: {
    loading: {
      times: false,
      doingBooking: false,
      signal: '',
    },
    modalState: 0,
    selectingProvider: false,
    selectingLocation: false,
    timeSlotsToShowMobile: 2,
    didSwipe: false,
    showConfirmationModal: false,
    formErrors: {
      ssn: false,
      ssnAge: false,
      email: false,
      phone: false,
    },
    singleBookingHeadline: window.singleBookingHeadline,
    calendarViewType: 'week',
    showGetNextAvailableTimeButton: false,
    /* 
    Keep track of whether the user is doing a BankID signature on another device or the same device.
    This is used to display messages accordingly.
    */
    signingBankIDOnOtherDevice: false,
    signingBankIDOnSameDevice: false,
  },
  unbookableTreatments: window.profetWPVars.non_bookable_treatments,
  unbookableTreatmentMessage:
    window.profetWPVars.non_bookable_treatment_message,
  firstLoadForActivity: false,
  slickOptions: {
    slidesToShow: 5.5,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    prevArrow:
      '<a class="slick-arrow arrow-prev"><img src="/wp-content/themes/nordiskakliniken/dist/images/chevron-left.svg"></a>',
    nextArrow:
      '<a class="slick-arrow arrow-next"><img src="/wp-content/themes/nordiskakliniken/dist/images/chevron-right.svg"></a>',
  },
  activityGroups: {
    available: [],
    bookable: [],
    selected: false,
    withActivities: [],
    loaded: false,
  },
  activities: {
    active: [],
    available: [],
    selected: false,
    initialLoad: true,
    loaded: false,
  },
  providers: {
    available: [],
    selected: false,
  },
  locations: {
    available: [],
    selected: false,
  },
  dates: {
    current: {
      date: false,
      day: false,
      week: false,
      weekdays: [],
      month: false,
      monthName: false,
      year: false,
      previousWeek: false,
      nextWeek: false,
      weekStartDate: false,
      weekEndDate: false,
      checkBookingsToDate: false,
    },
    active: {
      date: false,
      day: false,
      week: false,
      weekdays: [],
      month: false,
      monthName: false,
      year: false,
      previousWeek: false,
      nextWeek: false,
      weekStartDate: false,
      weekEndDate: false,
      checkBookingsToDate: false,
      monthDates: [],
    },
  },
  availableTimes: [],
  loadedTimes: [],
  selectedSlot: false,
  patient: {
    firstName: '',
    lastName: '',
    ssn: '',
    email: '',
    phone: '',
    gdprConsent: false,
    newsletterSignup: false,
  },
  initiatedCheckout: false,
  booking: {
    message: false,
    timeStart: false,
    timeEnd: false,
    activityName: false,
    completed: false,
    autostartToken: false,
    backupOrderRef: false,
    autostartToken: false,
    authenticationFailed: false,
    orderRef: false,
    qrCode: false,
    nbrRuns: 0,
    qrStartToken: '',
    qrStartSecret: '',
    waitingForSign: false,
  },
  collectBankIDResponseTimeout: false,
  qrTimeout: false,
  bankIDLocation: 'sameDevice', // The location of the user's bank ID, either "sameDevice" or "otherDevice".
  customTreatmentDurations: {}, // An object with custom treatment durations that are edited through WP admin. These are fetched through a REST call when the Vue app is mounted */
  orderRefQueryParameterLoaded: false, // Track if we've loaded the orderRef through query parameters. This is used to determine if we should show any potential error messages in a custom popup since the usual
  infoBox: null, // Dynamic gray info box when booking activity */
};
